<template>
    <div
        class="header"
        ref="headerRef"
        :class="this_route == 'home' ? '' : 'header-popup'"
    >
        <div>
            <div v-show="nav_active > 0">
                <img v-if="currentLang === 'zh'" class="nav-logo" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/page_logo.png" alt="">
                <img v-else class="nav-logo-en" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/en_logo.png" alt="">
            </div>
        </div>

        <div class="nav">
            <div
                class="nav-list"
                :class="[
                    nav_active == item.id ? 'nav-list-active' : '',
                    currentLang === 'en' ? 'nav-list-en' : ''
                ]"
                v-for="item in nav_list"
                :key="item.id"
                @click="change_nav(item.id, $event)"
            >
                {{ currentLang === 'zh' ? item.name : item.en_name }}

                <h6 v-if="currentLang === 'zh' && nav_active === item.id">
                    {{ item.en_name }}
                </h6>

                <div
                    class="nav-community"
                    v-if="item.id == 5"
                    v-show="if_show_community"
                >
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/bilibili.png" alt="" @click="open_community_url('bilibili')"/>
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/douyin.png" alt="" @click="open_community_url('douyin')"/>
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/webo.png" alt="" @click="open_community_url('webo')"/>
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/xiaohongshu.png" alt="" @click="open_community_url('xiaohongshu')"/>
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/youtube.png" alt="" @click="open_community_url('youtube')" v-if="currentLang === 'en'"/>
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/x.png" alt="" @click="open_community_url('x')" v-if="currentLang === 'en'"/>
                </div>
            </div>

            <div
                class="add-want"
                :class="{ 'add-want-en': currentLang === 'en' }"
                @click="open_steam_url"
            >   
                <img src="https://web.tos-cn-shanghai.volces.com/wangri/assets/steam_icon.png" alt="">
                {{ currentLang === 'zh' ? '加入愿望单' : 'Wishlist' }}
            </div>

            <div class="lang-switch" @click="toggleLanguage">
                <span class="lang-text">{{ currentLang === 'zh' ? 'EN' : '中' }}</span>
                <span class="lang-gap-icon">⇌</span>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, watch, ref, onMounted, onBeforeUnmount } from 'vue'
import $bus from "../bus/index"
import { useRouter, useRoute } from 'vue-router'

export default defineComponent({
    setup() {
        const nav_active = ref(0)
        const router = useRouter()
        const route = useRoute()
        const this_route = ref('home')
        const if_show_community = ref(false)
        const headerRef = ref(null)
        const currentLang = ref('zh')

        const routeUrl = router.resolve({ path: '/about_us' })

        const nav_list = ref([
            { name: '首页', en_name: 'HOME', id: 0 },
            { name: '世界观', en_name: 'LORE', id: 1 },
            { name: '游戏', en_name: 'GAME', id: 2 },
            { name: '壁纸', en_name: 'WALLPAPERS', id: 3 },
            { name: '资讯', en_name: 'NEWS', id: 4 },
            { name: '社区', en_name: 'COMMUNITY', id: 5 },
            { name: '联系我们', en_name: 'CONTACT US', id: 6 },
        ])

        watch(
            () => route.name,
            (newVal) => {
                this_route.value = newVal
                if_show_community.value = false

                if (newVal == 'news_detail') {
                    nav_active.value = 4
                } else if (newVal == 'about_us') {
                    nav_active.value = 6
                }
            },
            { immediate: true }
        )
        const open_community_url = (value) => {
            switch (value) {
                case 'bilibili':
                    window.open('https://space.bilibili.com/3546813030205509?spm_id_from=888.14.0.0', '_blank')
                    break
                case 'douyin':
                    window.open('https://v.douyin.com/Haq3kMv8mwA/ 7@2.com', '_blank')
                    break
                case 'webo':
                    window.open('https://weibo.com/u/8462703455', '_blank')
                    break
                case 'xiaohongshu':
                    window.open('https://xhslink.cn/o/2hn051kYb4T', '_blank')
                    break
                case 'youtube':
                    window.open('https://www.youtube.com/channel/UCCk9YgqZ4IEL42yoxxg2zXA', '_blank')
                    break
                case 'x':
                    window.open('https://x.com/The_wonder_ww', '_blank')
                    break
                default:
                    break
            }
        }
        const closeCommunity = () => {
            if_show_community.value = false
        }

        const handleDocumentClick = (event) => {
            const headerEl = headerRef.value
            if (!headerEl) return
            if (!headerEl.contains(event.target)) {
                closeCommunity()
            }
        }

        const open_steam_url = () => {
            const steamUrl = 'https://store.steampowered.com/app/5063690?utm_source=official_website' // Replace with the actual Steam URL
            window.open(steamUrl, '_blank')
        }

        function toggleLanguage() {
            currentLang.value = currentLang.value === 'zh' ? 'en' : 'zh'
            localStorage.setItem('lang', currentLang.value)

            if(route.name == 'news_detail' || route.name == 'mobile_news_detail') {
                window.location.reload();
                return;
            }
            window.location.href = window.location.origin + window.location.pathname;
        }

        const change_nav = (id, event) => {
            switch (id) {
                case 5:
                    if (event) event.stopPropagation()
                    if_show_community.value = !if_show_community.value
                    break
                case 6:
                    router.push(routeUrl.href)
                    break
                default:
                    if (this_route.value != 'home') {
                        router.push({ path: '/', query: { nav_active: id } })
                        nav_active.value = id
                        return
                    }
                    nav_active.value = id
                    $bus.emit('change_choice_id', { id: id })
            }
        }

        const changeNavHandler = (data) => {
            if (data.id > 4) return
            nav_active.value = data.id
            if_show_community.value = false
        }

        onMounted(() => {
            const savedLang = localStorage.getItem('lang')
            if (savedLang === 'zh' || savedLang === 'en') {
                currentLang.value = savedLang
            }

            document.addEventListener('click', handleDocumentClick)
            $bus.on('change_nav_id', changeNavHandler)
        })

        onBeforeUnmount(() => {
            document.removeEventListener('click', handleDocumentClick)
            if ($bus.off) {
                $bus.off('change_nav_id', changeNavHandler)
            }
        })

        return {
            nav_list,
            nav_active,
            this_route,
            if_show_community,
            headerRef,
            currentLang,
            toggleLanguage,
            change_nav,
            open_steam_url,
            open_community_url
        }
    }
})
</script>

<style scoped lang="less">
.header{
    position: fixed;
    top: 0;
    padding-top: 48px;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 106px;
    background-color: transparent;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 50px;

    .nav-logo{
        width: 158px;
        height: 112px;
        vertical-align: middle;
    }
    .nav-logo-en{
        width: 158px;
        transform: translateY(-10px);
        // height: 89px;
        // vertical-align: middle;
    }
    .nav{
        width: 65%;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        height: 100%;

        .nav-list{
            position: relative;
            margin-right: 60px;
            font-size: 22px;
            color: #5b5c5e;
            font-family: "黑体";
            font-weight: 600;
            white-space: nowrap;
            cursor: none;

            &:nth-child(7){
                margin-right: 30px;
            }

            h6{
                position: absolute;
                left: 0;
                top: 100%;
                font-size: 12px;
                font-weight: 500;
                padding: 3px;
                letter-spacing: 1px;
                white-space: nowrap;
            }

            &:hover{
                color: #eeeeee;
            }
        }

        .nav-list-en {
            font-size: 18px;
            letter-spacing: 1px;
        }

        .add-want{
            padding: 0 20px;
            height: 30px;
            font-size: 20px;
            color: #7c8fa0;
            font-family: "黑体";
            margin-right: 30px;
            line-height: 30px;
            transform: translateY(-5px);
            border: 1px solid #7c8fa0;
            opacity: 0.8;
            position: relative;
            cursor: none;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                height: 25px;
                vertical-align: middle;
                margin-right: 10px;
            }

            // &::after{
            //     content: "WISHLIST";
            //     display: inline-block;
            //     position: absolute;
            //     bottom: -8px;
            //     right: -6px;
            //     font-size: 12px;
            //     transform: scale(0.5);
            // }

            &:hover{
                opacity: 1;
            }

            &:active {
                opacity: 1;
            }
        }

        .add-want-en::after{
            content: '';
        }

        .nav-list-active{
            &::after{
                content: '';
                display: inline-block;
                position: absolute;
                width: 100%;
                left: 0;
                top: calc(100% + 22px);
                border-bottom: 1px solid #eeeeee;
            }
            transform: scale(1.2);
            color: #eeeeee;
        }

        .nav-list-en.nav-list-active{
            &::after{
                top: 100%;
            }
        }
    }
}

.header-popup{
    background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.8) 0%,
        rgba(0, 0, 0, 0.8) 50%,
        rgba(0, 0, 0, 0) 100%
    );
}

.nav-community{
    position: absolute;
    width: 40px;
    top: calc(100% +  30px);
    left: 0;
    background-color: #2a2b35;
    text-align: center;
    padding: 10px 5px;
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    .community-icon{
        width: 34px;
        height: 34px;
        opacity: 0.6;
        margin-bottom: 0;

        &:hover{
            opacity: 1;
        }
    }
}

.lang-switch {
    position: relative;
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 2px solid rgba(255,255,255,0.22);
    background: rgba(18, 18, 28, 0.9);
    color: rgba(255,255,255,0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: none;
    outline: none;
    transition: all 0.3s ease;
    margin-right: 20px;
    transform: translateY(-4px);
}

.lang-text {
    font-size: 14px;
    font-weight: 300;
    line-height: 1;
}

.lang-gap-icon {
    position: absolute;
    right: -2px;
    bottom: -7px;
    width: 14px;
    height: 14px;
    background: rgba(18, 18, 28, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: rgba(255,255,255,0.55);
    z-index: 2;
}

.lang-gap-icon::before {
    content: '';
    position: absolute;
    inset: -1px;
    background: rgba(18, 18, 28, 0.9);
    z-index: -1;
}

.lang-switch:hover {
    color: #fff;
    border-color: #fff;
}

.lang-switch:hover .lang-gap-icon {
    color: #fff;
}

@media (max-width: 1730px) {
    .header{
        position: fixed;
        top: 0;
        padding-top: 48px;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 106px;
        background-color: transparent;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 50px;

        .nav-logo{
            width: 158px;
            height: 112px;
            vertical-align: middle;
        }
        .nav-logo-en{
            width: 158px;
            transform: translateY(-10px);
            // height: 89px;
            // vertical-align: middle;
        }
        .nav{
            width: 65%;
            display: flex;
            justify-content: flex-end;
            align-items: flex-start;
            height: 100%;

            .nav-list{
                position: relative;
                margin-right: 40px;
                font-size: 20px;
                color: #5b5c5e;
                font-family: "黑体";
                font-weight: 600;
                white-space: nowrap;

                &:nth-child(7){
                    margin-right: 20px;
                }

                h6{
                    position: absolute;
                    left: 0;
                    top: 100%;
                    font-size: 12px;
                    font-weight: 500;
                    padding: 3px;
                    letter-spacing: 1px;
                    white-space: nowrap;
                }

                &:hover{
                    color: #eeeeee;
                }
            }

            .nav-list-en {
                font-size: 16px;
                letter-spacing: 1px;
            }
            
            .add-want{
                padding: 0 20px;
                height: 25px;
                font-size: 16px;
                color: #7c8fa0;
                font-family: "黑体";
                margin-right: 30px;
                transform: translateY(-2px);
                border: 1px solid #7c8fa0;
                opacity: 0.8;
                position: relative;
                cursor: none;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    height: 23px;
                    vertical-align: middle;
                    margin-right: 10px;
                }
                // &::after{
                //     content: "WISHLIST";
                //     display: inline-block;
                //     position: absolute;
                //     bottom: -6px;
                //     right: -11px;
                //     font-size: 12px;
                //     transform: scale(0.3);
                // }

                &:hover{
                    opacity: 1;
                }

                &:active {
                    opacity: 1;
                }
            }

            .add-want-en::after{
                content: '';
            }

            .nav-list-active{
                &::after{
                    content: '';
                    display: inline-block;
                    position: absolute;
                    width: 100%;
                    left: 0;
                    top: calc(100% + 22px);
                    border-bottom: 1px solid #eeeeee;
                }
                transform: scale(1.2);
                color: #eeeeee;
            }

            .nav-list-en.nav-list-active{
                &::after{
                    top: 100%;
                }
            }
        }
    }

    .lang-switch {
        position: relative;
        width: 25px;
        height: 25px;
        box-sizing: border-box;
        border-radius: 50%;
        border: 2px solid rgba(255,255,255,0.22);
        background: rgba(18, 18, 28, 0.9);
        color: rgba(255,255,255,0.65);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: none;
        outline: none;
        transition: all 0.3s ease;
        margin-right: 20px;
        transform: translateY(-2px);
    }

    .lang-text {
        font-size: 12px;
        font-weight: 300;
        line-height: 1;
    }

    .lang-gap-icon {
        position: absolute;
        right: -3px;
        bottom: -7px;
        width: 14px;
        height: 12px;
        background: rgba(18, 18, 28, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: rgba(255,255,255,0.55);
        z-index: 2;
    }

    .lang-gap-icon::before {
        content: '';
        position: absolute;
        inset: -1px;
        background: rgba(18, 18, 28, 0.9);
        z-index: -1;
    }

    .lang-switch:hover {
        color: #fff;
        border-color: #fff;
    }

    .lang-switch:hover .lang-gap-icon {
        color: #fff;
    }
}

@media (max-width: 1360px) {
    .header{
        position: fixed;
        top: 0;
        padding-top: 48px;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 106px;
        background-color: transparent;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 50px;

        .nav-logo{
            width: 126px;
            height: 89px;
            vertical-align: middle;
        }
        .nav-logo-en{
            width: 126px;
            transform: translateY(-10px);
            // height: 89px;
            // vertical-align: middle;
        }
        .nav{
            width: 75%;
            display: flex;
            justify-content: flex-end;
            align-items: flex-start;
            height: 100%;

            .nav-list{
                position: relative;
                margin-right: 30px;
                font-size: 18px;
                color: #5b5c5e;
                font-family: "黑体";
                font-weight: 600;
                white-space: nowrap;

                &:nth-child(7){
                    margin-right: 15px;
                }

                h6{
                    position: absolute;
                    left: 0;
                    top: 100%;
                    font-size: 12px;
                    font-weight: 500;
                    padding: 3px;
                    letter-spacing: 1px;
                    white-space: nowrap;
                }

                &:hover{
                    color: #eeeeee;
                }
            }

            .nav-list-en {
                font-size: 14px;
                letter-spacing: 1px;
            }
            
            .add-want{
                padding: 0 15px;
                height: 25px;
                font-size: 14px;
                color: #7c8fa0;
                font-family: "黑体";
                margin-right: 30px;
                transform: translateY(-2px);
                border: 1px solid #7c8fa0;
                opacity: 0.8;
                position: relative;
                cursor: none;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    height: 22px;
                    vertical-align: middle;
                    margin-right: 10px;
                }
                &:hover{
                    opacity: 1;
                }

                &:active {
                    opacity: 1;
                }
            }

            .add-want-en::after{
                content: '';
            }

            .nav-list-active{
                &::after{
                    content: '';
                    display: inline-block;
                    position: absolute;
                    width: 100%;
                    left: 0;
                    top: calc(100% + 22px);
                    border-bottom: 1px solid #eeeeee;
                }
                transform: scale(1.2);
                color: #eeeeee;
            }

            .nav-list-en.nav-list-active{
                &::after{
                    top: 100%;
                }
            }
        }
    }

    .lang-switch {
        position: relative;
        width: 25px;
        height: 25px;
        box-sizing: border-box;
        border-radius: 50%;
        border: 2px solid rgba(255,255,255,0.22);
        background: rgba(18, 18, 28, 0.9);
        color: rgba(255,255,255,0.65);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: none;
        outline: none;
        transition: all 0.3s ease;
        margin-right: 20px;
        transform: translateY(-2px);
    }

    .lang-text {
        font-size: 12px;
        font-weight: 300;
        line-height: 1;
    }

    .lang-gap-icon {
        position: absolute;
        right: -3px;
        bottom: -7px;
        width: 14px;
        height: 12px;
        background: rgba(18, 18, 28, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: rgba(255,255,255,0.55);
        z-index: 2;
    }

    .lang-gap-icon::before {
        content: '';
        position: absolute;
        inset: -1px;
        background: rgba(18, 18, 28, 0.9);
        z-index: -1;
    }

    .lang-switch:hover {
        color: #fff;
        border-color: #fff;
    }

    .lang-switch:hover .lang-gap-icon {
        color: #fff;
    }
}
</style>